import { useTranslation } from 'react-i18next'
import { invalidateNews, useCreateCustomerNews } from 'src/api/news'
import { useGetCustomerLocalities, useGetGrouppedLocalities } from 'src/api/localities'
import { useGetServiceStations } from 'src/api/service-station'
import { useGetAllStorageWithCustomers } from 'src/api/storage'
import { NewsArticleForm, NewsArticleFormValues } from 'src/forms/NewsArticleForm'
import { ShowDialogProps } from 'src/show-dialog'

interface CreateNewsArticleDialogProps extends ShowDialogProps {
  customerId: number
  hasLocalities?: boolean
  hasServiceStations?: boolean
  hasStorages?: boolean
}

const CreateNewsArticleDialog: React.FC<CreateNewsArticleDialogProps> = ({ pop, customerId, hasLocalities, hasServiceStations, hasStorages }) => {
  const { t: translate } = useTranslation(['common'])
  const createMutation = useCreateCustomerNews(customerId)
  const { data: groupedLocalities } = useGetGrouppedLocalities(customerId, { enabled: hasLocalities })
  const { data: localities } = useGetCustomerLocalities({ clientId: customerId })
  const { data: serviceStations } = useGetServiceStations(customerId)
  const { data: storages } = useGetAllStorageWithCustomers(customerId)

  const handleSubmit = async (values: NewsArticleFormValues) => {
    await createMutation.mutateAsync(values)
    invalidateNews.all(customerId)
    pop(true)
  }

  return (
    <NewsArticleForm
      title={translate('create-news-article', { ns: 'news' })}
      onSubmit={handleSubmit}
      onCancel={() => pop()}
      localityGroups={groupedLocalities?.localityGroups ?? []}
      localities={(localities as any[]) ?? []}
      serviceStations={(serviceStations as any[]) ?? []}
      storages={(storages as any[]) ?? []}
      isLoading={createMutation.isLoading}
      disableGlobalTarget
      hasLocalities={hasLocalities}
      hasServiceStations={hasServiceStations}
      hasStorages={hasStorages}
    />
  )
}

export default CreateNewsArticleDialog
